import React, { useState } from "react";
import { useOutletContext } from "react-router-dom";

const ActiveBalance = () => {
  const { infoData } = useOutletContext();
  const E3 = infoData?.E3;
  const E4 = infoData?.E4;

  const [formData, setFormData] = useState({
    tempNo: "",
    batteryType: "",
    balanceCurrent: "",
    cellReferenceVoltage: "",
    batteryCapacitySetting: "",
    actualBatteryCapacity: "",
    dormancyWaitingTime: "",
    specialChargeSwitch: "",
    currentCalibration: "",
    lowCapacityAlarm: "",
    equalizingStartVolt: "",
    openingDifferentialPressure: "",
    equalizingSwitch: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
  };

  return (
    <div className="overflow-x-auto mt-3 mb-5 px-1">
      <form onSubmit={handleSubmit}>
        <table className="table table-compact w-full">
          <thead className="text-white">
            <tr>
              <th className="bg-primary text-xs md:text-base">Project</th>
              <th className="bg-primary text-xs md:text-base">Machine</th>
              <th className="bg-primary text-xs md:text-base">Setting</th>
            </tr>
          </thead>
          <tbody>
            {/* row 1 ------------------------------------------------------------------------------ */}
            <tr>
              <td className="w-48 md:w-80">
                <h3 className="md:text-base font-medium whitespace-normal">
                  No. Of Temperature
                </h3>
              </td>
              <td>
                <div className="badge bg-orange-50 text-accent border-orange-400 px-2 gap-2 md:text-base font-medium">
                  {/* {F1?.tempNo} */}
                </div>
              </td>
              <td className="w-48 md:w-64">
                <input
                  type="number"
                  name="tempNo"
                  placeholder="Type here"
                  className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
                  value={formData.tempNo}
                  onChange={handleChange}
                />
              </td>
            </tr>
            {/* --------------------------------------------------------------------------------------- */}

            {/* row 2 ------------------------------------------------------------------------------ */}
            <tr>
              <td className="w-48 md:w-80">
                <h3 className="md:text-base font-medium whitespace-normal">
                  Battery Type
                </h3>
              </td>
              <td>
                <div className="badge bg-green-50 text-black border-green-400 pb-1 px-2 gap-2 md:text-base font-medium">
                  {E3?.cellType}
                </div>
              </td>
              <td className="w-48 md:w-64">
                <input
                  type="number"
                  name="batteryType"
                  placeholder="Type here"
                  className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
                  value={formData.batteryType}
                  onChange={handleChange}
                />
              </td>
            </tr>
            {/* --------------------------------------------------------------------------------------- */}

            {/* row 3 ------------------------------------------------------------------------------ */}
            <tr>
              <td className="w-48 md:w-80">
                <h3 className="md:text-base font-medium whitespace-normal">
                  Balance Current
                </h3>
              </td>
              <td>
                {/* <h3 className="md:text-base font-medium">{F0?.soc} A</h3> */}
              </td>
              <td className="w-48 md:w-64">
                <input
                  type="number"
                  name="balanceCurrent"
                  placeholder="Type here"
                  className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
                  value={formData.balanceCurrent}
                  onChange={handleChange}
                />
              </td>
            </tr>
            {/* --------------------------------------------------------------------------------------- */}

            {/* row 4 ------------------------------------------------------------------------------ */}
            <tr>
              <td className="w-48 md:w-80">
                <h3 className="md:text-base font-medium whitespace-normal">
                  Cell Reference Voltage
                </h3>
              </td>
              <td>
                {/* <h3 className="md:text-base font-medium">{F0?.volt} V</h3> */}
              </td>
              <td className="w-48 md:w-64">
                <input
                  type="number"
                  name="cellReferenceVoltage"
                  placeholder="Type here"
                  className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
                  value={formData.cellReferenceVoltage}
                  onChange={handleChange}
                />
              </td>
            </tr>
            {/* --------------------------------------------------------------------------------------- */}

            {/* row 5 ------------------------------------------------------------------------------ */}
            <tr>
              <td className="w-48 md:w-80">
                <h3 className="md:text-base font-medium whitespace-normal">
                  Battery Capacity Setting
                </h3>
              </td>
              <td>
                <h3 className="md:text-base font-medium">
                  {E3?.packCapacity}
                </h3>
              </td>
              <td className="w-48 md:w-64">
                <input
                  type="number"
                  name="batteryCapacitySetting"
                  placeholder="Type here"
                  className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
                  value={formData.batteryCapacitySetting}
                  onChange={handleChange}
                />
              </td>
            </tr>
            {/* --------------------------------------------------------------------------------------- */}

            {/* row 6 ------------------------------------------------------------------------------ */}
            <tr>
              <td className="w-48 md:w-80">
                <h3 className="md:text-base font-medium whitespace-normal">
                  Actual Battery Capacity
                </h3>
              </td>
              <td>
                <h3 className="md:text-base font-medium">
                  {/* {E4?.actualBatteryCapacity} AH */}
                </h3>
              </td>
              <td className="w-48 md:w-64">
                <input
                  type="number"
                  name="actualBatteryCapacity"
                  placeholder="Type here"
                  className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
                  value={formData.actualBatteryCapacity}
                  onChange={handleChange}
                />
              </td>
            </tr>
            {/* --------------------------------------------------------------------------------------- */}

            {/* row 7 ------------------------------------------------------------------------------ */}
            <tr>
              <td className="w-48 md:w-80">
                <h3 className="md:text-base font-medium whitespace-normal">
                  Dormancy Waiting Time
                </h3>
              </td>
              <td>
                <h3 className="md:text-base font-medium">
                  {E3?.sleepTime}
                </h3>
              </td>
              <td className="w-48 md:w-64">
                <input
                  type="number"
                  name="dormancyWaitingTime"
                  placeholder="Type here"
                  className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
                  value={formData.dormancyWaitingTime}
                  onChange={handleChange}
                />
              </td>
            </tr>
            {/* --------------------------------------------------------------------------------------- */}

            {/* row 8 ------------------------------------------------------------------------------ */}
            <tr>
              <td className="w-48 md:w-80">
                <h3 className="md:text-base font-medium whitespace-normal">
                  Special Charge Switch
                </h3>
              </td>
              <td>
                <h3 className="md:text-base font-medium">
                  {E4?.specialChargeSwitch}
                </h3>
              </td>
              <td className="w-48 md:w-64">
                <input
                  type="number"
                  name="specialChargeSwitch"
                  placeholder="Type here"
                  className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
                  value={formData.specialChargeSwitch}
                  onChange={handleChange}
                />
              </td>
            </tr>
            {/* --------------------------------------------------------------------------------------- */}

            {/* row 9 ------------------------------------------------------------------------------ */}
            <tr>
              <td className="w-48 md:w-80">
                <h3 className="md:text-base font-medium whitespace-normal">
                  Current Calibration
                </h3>
              </td>
              <td>
                <h3 className="md:text-base font-medium">
                  {E4?.currentCalibration}
                </h3>
              </td>
              <td className="w-48 md:w-64">
                <input
                  type="number"
                  name="currentCalibration"
                  placeholder="Type here"
                  className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
                  value={formData.currentCalibration}
                  onChange={handleChange}
                />
              </td>
            </tr>
            {/* --------------------------------------------------------------------------------------- */}

            {/* row 10 ------------------------------------------------------------------------------ */}
            <tr>
              <td className="w-48 md:w-80">
                <h3 className="md:text-base font-medium whitespace-normal">
                  Low Capacity Alarm
                </h3>
              </td>
              <td>
                <h3 className="md:text-base font-medium">
                  {E4?.lowCapacityAlarmValue}
                </h3>
              </td>
              <td className="w-48 md:w-64">
                <input
                  type="number"
                  name="lowCapacityAlarm"
                  placeholder="Type here"
                  className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
                  value={formData.lowCapacityAlarm}
                  onChange={handleChange}
                />
              </td>
            </tr>
            {/* --------------------------------------------------------------------------------------- */}

            {/* row 11 ------------------------------------------------------------------------------ */}
            <tr>
              <td className="w-48 md:w-80">
                <h3 className="md:text-base font-medium whitespace-normal">
                  Equalizing Start Volt
                </h3>
              </td>
              <td>
                <h3 className="md:text-base font-medium">
                  {E3?.balanceTrigVolt} V
                </h3>
              </td>
              <td className="w-48 md:w-64">
                <input
                  type="number"
                  name="equalizingStartVolt"
                  placeholder="Type here"
                  className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
                  value={formData.equalizingStartVolt}
                  onChange={handleChange}
                />
              </td>
            </tr>
            {/* --------------------------------------------------------------------------------------- */}

            {/* row 12 ------------------------------------------------------------------------------ */}
            <tr>
              <td className="w-48 md:w-80">
                <h3 className="md:text-base font-medium whitespace-normal">
                  Opening Differential Pressure
                </h3>
              </td>
              <td>
                <h3 className="md:text-base font-medium">
                  {E3?.balanceDiffVolt} V
                </h3>
              </td>
              <td className="w-48 md:w-64">
                <input
                  type="number"
                  name="openingDifferentialPressure"
                  placeholder="Type here"
                  className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
                  value={formData.openingDifferentialPressure}
                  onChange={handleChange}
                />
              </td>
            </tr>
            {/* --------------------------------------------------------------------------------------- */}

            {/* row 13 ------------------------------------------------------------------------------ */}
            <tr>
              <td className="w-48 md:w-80">
                <h3 className="md:text-base font-medium whitespace-normal">
                  Equalizing Switch
                </h3>
              </td>
              <td>
                <h3 className="md:text-base font-medium">
                  {E3?.balanceSwitch}
                </h3>
              </td>
              <td className="w-48 md:w-64">
                <input
                  type="number"
                  name="equalizingSwitch"
                  placeholder="Type here"
                  className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
                  value={formData.equalizingSwitch}
                  onChange={handleChange}
                />
              </td>
            </tr>
            {/* --------------------------------------------------------------------------------------- */}
          </tbody>
        </table>
        <div className="flex justify-end pr-2">
          <div className="w-40 mt-4">
            <button
              type="submit"
              className="btn btn-primary btn-xs md:btn-sm w-40"
            >
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ActiveBalance;
